import { PilotId } from '~/types/PilotId';

/**
 * Lets a Super Admin signed in to the General client act on another tenant.
 * The backend honours it for Super Admins only and rejects it for anyone else.
 */
export const TARGET_CLIENT_HEADER = 'X-Target-Client-Id';

let targetClientId: PilotId | null = null;

export function setTargetClientId(clientId: PilotId | null) {
  targetClientId = clientId;
}

export function targetClientHeader(): Record<string, string> {
  return targetClientId === null
    ? {}
    : { [TARGET_CLIENT_HEADER]: String(targetClientId) };
}
